import {flushAmplitude} from "@pg-mono/amplitude";

const AMPLITUDE_FLUSH_TIMEOUT_MS = 200;

/**
 * Amplitude's default transport has no `sendBeacon` fallback, so a track call right before a real page
 * unload (full navigation, not SPA) can be dropped silently. Callers should await this before navigating.
 */
export const waitForAmplitudeFlush = async (): Promise<void> => {
    await Promise.race([
        flushAmplitude(),
        new Promise<void>((resolve) => {
            window.setTimeout(resolve, AMPLITUDE_FLUSH_TIMEOUT_MS);
        })
    ]);
};
import {flushAmplitude} from "@pg-mono/amplitude";

const AMPLITUDE_FLUSH_TIMEOUT_MS = 200;

/**
 * Amplitude's default transport has no `sendBeacon` fallback, so a track call right before a real page
 * unload (full navigation, not SPA) can be dropped silently. Callers should await this before navigating.
 */
export const waitForAmplitudeFlush = async (): Promise<void> => {
    await Promise.race([
        flushAmplitude(),
        new Promise<void>((resolve) => {
            window.setTimeout(resolve, AMPLITUDE_FLUSH_TIMEOUT_MS);
        })
    ]);
};
